import React, { useState, useEffect } from "react";
import Layout from "../../components/UI/layout";
import DetailNews from "../../components/News/DetailNews/DetailNews";
import { getNewsBySlugs } from "../../services/Noticias/getNewsBySlugs";
import { SEO as Seo } from "../../components/UI/seo";

export async function getServerData({ params }) {
  const newsSlug = params.id;
  const detailNews = await getNewsBySlugs(newsSlug);

  const canonicalUrl = `https://peabody.com.ar/novedades/${newsSlug}/`;

  return {
    props: {
      news: detailNews,
      canonicalUrl
    },
  };
}

const DetallePage = ({ serverData }) => {
  const { news } = serverData;
  const [countryOn, setCountryOn] = useState("");

  console.log(news)

  useEffect(() => {
    if (typeof window !== "undefined") {
      const countryFromLocalStorage = localStorage.getItem("country");
      setCountryOn(countryFromLocalStorage);
    }
  }, []);

  return (
    <Layout>
      <DetailNews country={countryOn} news={news} />
    </Layout>
  );
};

export default DetallePage;

export const Head = ({ serverData }) => {

  if (!serverData?.news) {
    return null;  // Evitar renderizar Head si los datos no están listos
  }

  const { news, canonicalUrl } = serverData;

  return(
    <Seo title={`${news.name} | Peabody`}>
      <link rel="canonical" href={canonicalUrl}/>
    </Seo>
  )
}
